/**
 * État de la page « Vue d'ensemble » (plan F3) : tout vit dans l'URL, rien en `useState`.
 * `readOverviewParams` dérive `{ from, to }` de l'onglet actif — le calendrier ne dépend que
 * de `ancre`/`mode`, les deux autres onglets lisent `de`/`a` (défaut : le mois de `today`).
 * Le calendrier n'écrit jamais `de`/`a` (§ F3).
 */

import { monthBounds, weekBounds } from './calendar.js';

export const OVERVIEW_TABS = Object.freeze(['calendrier', 'charge', 'indicateurs']);
export const OVERVIEW_MODES = Object.freeze(['mois', 'semaine']);

function monthStartEnd(iso) {
  const [year, month] = iso.split('-').map(Number);
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const prefix = iso.slice(0, 7);
  return { from: `${prefix}-01`, to: `${prefix}-${String(lastDay).padStart(2, '0')}` };
}

/**
 * @param {URLSearchParams} searchParams
 * @param {string} today ISO — jamais l'horloge du client (§ contrat, plan 1.2).
 */
export function readOverviewParams(searchParams, today) {
  const vueBrute = searchParams.get('vue');
  const vue = OVERVIEW_TABS.includes(vueBrute) ? vueBrute : 'calendrier';

  const modeBrut = searchParams.get('mode');
  const mode = OVERVIEW_MODES.includes(modeBrut) ? modeBrut : 'mois';

  const anchor = searchParams.get('ancre') || today;

  const teamId = searchParams.get('equipe') || undefined;
  const projectId = searchParams.get('projet') || undefined;
  const memberId = searchParams.get('membre') || undefined;

  let from;
  let to;
  if (vue === 'calendrier') {
    ({ from, to } = mode === 'semaine' ? weekBounds(anchor) : monthBounds(anchor));
  } else {
    const defaults = monthStartEnd(today);
    from = searchParams.get('de') || defaults.from;
    to = searchParams.get('a') || defaults.to;
  }

  return { vue, mode, anchor, from, to, teamId, projectId, memberId };
}

/**
 * Fusionne `patch` (clés = noms de paramètres d'URL : `vue`, `mode`, `ancre`, `equipe`,
 * `projet`, `membre`, `de`, `a`) dans `searchParams`. Une valeur vide/`null`/`undefined`
 * retire la clé plutôt que d'écrire une chaîne vide.
 */
export function writeOverviewParams(searchParams, patch) {
  const next = new URLSearchParams(searchParams);
  for (const [key, value] of Object.entries(patch)) {
    if (value === undefined || value === null || value === '') next.delete(key);
    else next.set(key, value);
  }
  return next;
}
